module.exports = __webpack_public_path__ + "minus.45a0af6c3e000338e5ed.png";


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/OESS_LFB_V2/src/assets/images/minus.png
// module id = ../../../../../src/assets/images/minus.png
// module chunks = main